import { render, staticRenderFns } from "./CtSelect.vue?vue&type=template&id=f06f362e&scoped=true"
import script from "./CtSelect.vue?vue&type=script&lang=js"
export * from "./CtSelect.vue?vue&type=script&lang=js"
import style0 from "./CtSelect.vue?vue&type=style&index=0&id=f06f362e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06f362e",
  null
  
)

export default component.exports